import { CasinoGameConfig, CasinoManagementApi } from '../../communication/casino-manager/CasinoManagementApi'

export enum CasinoGamesActionsTypes {
    GET_CASINO_GAME_CONFIGS_STARTED = 'GET_CASINO_GAME_CONFIGS_STARTED',
	GET_CASINO_GAME_CONFIGS_SUCCESS = 'GET_CASINO_GAME_CONFIGS_SUCCESS',
	GET_CASINO_GAME_CONFIGS_FAILURE = 'GET_CASINO_GAME_CONFIGS_FAILURE',
}

export type CasinoGamesAction =
    | { type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_STARTED }
    | { type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_SUCCESS; payload: { configs: CasinoGameConfig[] } }
    | { type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_FAILURE; payload: { error: Error } }

const getCasinoGameConfigsStarted = () => ({
	type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_STARTED,
})

const getCasinoGameConfigsSuccess = configs => ({
	type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_SUCCESS,
	payload: {
		configs,
	},
})

const getCasinoGameConfigsFailure = error => ({
	type: CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_FAILURE,
	payload: {
		error,
	},
})

export const getCasinoGames = () => dispatch => {
	dispatch(getCasinoGameConfigsStarted())
	CasinoManagementApi.getPlayableCasinoGames()
		.then(response => dispatch(getCasinoGameConfigsSuccess(response)))
		.catch(error => dispatch(getCasinoGameConfigsFailure(error)))
}
